module.exports = __webpack_public_path__ + "img/9791156330110.83b3c40b.jpg";